/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, action: NonNullable<unknown>, measured: NonNullable<unknown>, method: NonNullable<unknown>, path: NonNullable<unknown> }} Seo_Endpoint_OpeningInputs */

const en_seo_endpoint_opening = /** @type {(inputs: Seo_Endpoint_OpeningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The AnyAPI ${i?.name} ${i?.action} API returns ${i?.measured} data as normalized JSON from one ${i?.method} call to ${i?.path}.`)
};

const zh_hans1_seo_endpoint_opening = /** @type {(inputs: Seo_Endpoint_OpeningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AnyAPI 的 ${i?.name} ${i?.action} API 只需一次 ${i?.method} 请求 ${i?.path}，就以统一格式的 JSON 返回 ${i?.measured} 数据。`)
};

const pt_br2_seo_endpoint_opening = /** @type {(inputs: Seo_Endpoint_OpeningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O endpoint ${i?.action} da AnyAPI para ${i?.name} retorna dados de ${i?.measured} em JSON normalizado com uma chamada ${i?.method} para ${i?.path}.`)
};

const es_seo_endpoint_opening = /** @type {(inputs: Seo_Endpoint_OpeningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El endpoint ${i?.action} de AnyAPI para ${i?.name} devuelve datos de ${i?.measured} como JSON normalizado con una sola llamada ${i?.method} a ${i?.path}.`)
};

const fr_seo_endpoint_opening = /** @type {(inputs: Seo_Endpoint_OpeningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`L’API ${i?.name} ${i?.action} d’AnyAPI renvoie des données ${i?.measured} en JSON normalisé à partir d’un appel ${i?.method} à ${i?.path}.`)
};

const de_seo_endpoint_opening = /** @type {(inputs: Seo_Endpoint_OpeningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Die AnyAPI-${i?.name}-${i?.action}-API liefert ${i?.measured}-Daten als normalisiertes JSON aus einem ${i?.method}-Aufruf an ${i?.path}.`)
};

const ru_seo_endpoint_opening = /** @type {(inputs: Seo_Endpoint_OpeningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AnyAPI ${i?.name} ${i?.action} API возвращает данные ${i?.measured} в виде нормализованного JSON одним вызовом ${i?.method} к ${i?.path}.`)
};

const it_seo_endpoint_opening = /** @type {(inputs: Seo_Endpoint_OpeningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`L'API ${i?.name} ${i?.action} di AnyAPI restituisce dati ${i?.measured} come JSON normalizzato da una sola chiamata ${i?.method} a ${i?.path}.`)
};

/**
* | output |
* | --- |
* | "The AnyAPI {name} {action} API returns {measured} data as normalized JSON from one {method} call to {path}." |
*
* @param {Seo_Endpoint_OpeningInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_endpoint_opening = /** @type {((inputs: Seo_Endpoint_OpeningInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Endpoint_OpeningInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_endpoint_opening(inputs)
	if (locale === "pt-BR") return pt_br2_seo_endpoint_opening(inputs)
	if (locale === "es") return es_seo_endpoint_opening(inputs)
	if (locale === "fr") return fr_seo_endpoint_opening(inputs)
	if (locale === "de") return de_seo_endpoint_opening(inputs)
	if (locale === "ru") return ru_seo_endpoint_opening(inputs)
	if (locale === "it") return it_seo_endpoint_opening(inputs)
	return en_seo_endpoint_opening(inputs)
});